const weightLoss=[

    {
    label:"Approx Previous Weight (kg)",
    controlType:"number",
    options:[]
    },

    {
    label:"Approx Weight Now (kg)",
    controlType:"number",
    options:[]
    },
    
    {
    label:"Duration:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }


]

export default weightLoss
